/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { inject } from "@angular/core";
import { CanActivateFn, Router, ActivatedRouteSnapshot } from "@angular/router";
import { SessionService } from "../services/session.service";
import { QPilotService } from "../services/qpilot.service";
import { map, catchError } from "rxjs/operators";
import { of } from "rxjs";

/**
 * Guard to prevent Shopify sites from accessing certain routes
 * (e.g., Create Scheduled Order)
 *
 * This guard checks if the site's integration is Shopify.
 * If it is, the user is redirected to the access-denied page.
 */
export const nonShopifyGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const sessionService = inject(SessionService);
  const qpilotService = inject(QPilotService);
  const router = inject(Router);

  // Get siteId from route params (usually from parent route) or query params (for standalone routes)
  const siteId =
    route.paramMap.get("siteId") ||
    route.parent?.paramMap.get("siteId") ||
    route.queryParamMap.get("siteId");

  if (!siteId || !sessionService.accessToken) {
    console.warn("No siteId or access token available for nonShopifyGuard");
    return false;
  }

  // Fetch site data to check if it's Shopify
  // Uses getSite() which returns Integration data (matches scheduled-orders-list.component.ts:388)
  return qpilotService.getSite(Number(siteId), sessionService.accessToken).pipe(
    map((site) => {
      // Check Integration.Name property (matches old QMC pattern from line 406)
      const isShopify = (site as any).Integration?.Name === "Shopify";

      if (isShopify) {
        console.warn(
          "Create Scheduled Order is not available for Shopify sites",
        );
        // Redirect to access-denied page with reason and siteId
        void router.navigate(["/access-denied"], {
          queryParams: {
            reason: "shopify-create-order",
            siteId: siteId,
          },
        });
        return false;
      }

      return true;
    }),
    catchError((error) => {
      console.error("Error checking site data:", error);
      // Allow access on error to avoid blocking users
      return of(true);
    }),
  );
};
